'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PushBox = require('./PushBox/PushBox');

var _PushBox2 = _interopRequireDefault(_PushBox);

var _CustomBox = require('./CustomBox/CustomBox');

var _CustomBox2 = _interopRequireDefault(_CustomBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  PushBox: _PushBox2.default,
  CustomBox: _CustomBox2.default
};